const reservation = {
    init: () => {
        $('form').validate();
    }
};